import { Heading4, SmallText } from '@sb1/ffe-core-react';
import Image from '../image/Image';
import { Link, useLocation } from 'react-router';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { useEffect, useRef } from 'react';
import styles from './wave-card.module.less';

const LinkOrDiv = ({ to, children, ...rest }) => {
    const trackIfLink = () => {
        trackEvent('wave-card', 'click-link', { url: to });
    };

    if (to) {
        return (
            <Link onClick={trackIfLink} to={to} {...rest}>
                {children}
            </Link>
        );
    }

    return <div {...rest}>{children}</div>;
};

export const WaveCard = ({
    id,
    subText = '',
    title = '',
    bodyText = '',
    src = '',
    topColor = '#f2f2f9',
    flipTitleDisplay = false,
    hideShadow = false,
    to,
}) => {
    const elementRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (elementRef.current && location.hash === `#${id}`) {
            elementRef.current.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
    }, [location, id]);

    return (
        <LinkOrDiv
            to={to}
            className={[styles.card, hideShadow ? styles.hideShadow : '', to ? styles.cardHoverEffects : ''].join(' ')}
            style={{ backgroundColor: topColor }}
            ref={elementRef}
        >
            <div className={styles.topContent}>
                <SmallText>{subText}</SmallText>
            </div>
            <div className={styles.bottomContent}>
                <Image className={styles.image} src={src} />
                <div className={[styles.textWrapper, flipTitleDisplay ? styles.flipTextDirection : ''].join(' ')}>
                    <Heading4 noMargin>{title}</Heading4>
                    <span className={styles.bodyText}>{bodyText}</span>
                </div>
            </div>
        </LinkOrDiv>
    );
};
